import React from "react";
import {
  Box,
  Typography,
  // Container,
  // Card,
  // CardMedia,
  // CardContent,
  Chip,
  TextField,
  InputLabel,
  InputAdornment,
  Button,
} from "@mui/material";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import "./GiftCard.css";
import Backdrop from "@mui/material/Backdrop";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import { BsLink } from "react-icons/bs";
import logoSvg from "./images/Frame 1212.png";
import giftImg1 from "./images/Frame 1214.png";
import giftImg2 from "./images/Frame 1213.png";
import giftImg3 from "./images/Frame 1212.png";
import giftImg4 from "./images/Frame 180.png";
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 320,
  bgcolor: "background.paper",
  border: "0px solid #000",
  boxShadow: 24,
  p: 4,
};

const imgArr = [
  { img: giftImg1 },
  { img: giftImg2 },
  { img: giftImg3 },
  { img: giftImg4 },
];

function SampleNextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{ ...style, display: "block", backgroundColor: "#F0FAF9" }}
      onClick={onClick}
    />
  );
}
function SamplePrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{ ...style, display: "block", backgroundColor: "#F0FAF9" }}
      onClick={onClick}
    />
  );
}
function SampleNextArrow1(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{ ...style, display: "none", backgroundColor: "#F0FAF9" }}
      onClick={onClick}
    />
  );
}
function SamplePrevArrow1(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{ ...style, display: "none", backgroundColor: "#F0FAF9" }}
      onClick={onClick}
    />
  );
}
const GiftCard = (props) => {
  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
  };
  const settings1 = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    nextArrow: <SampleNextArrow1 />,
    prevArrow: <SamplePrevArrow1 />,
    slidesToShow: 4,
    slidesToScroll: 4,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 2,
          infinite: true,
        },
      },
      {
        breakpoint: 900,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          initialSlide: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          initialSlide: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  const [open, setOpen] = React.useState(false);
  const handleOpenModal = () => setOpen(true);
  const handleClose = () => setOpen(false);
  return (
    <Box component={"div"} style={{ width: "100%", padding: "10px" }}>
      <Box component={"div"} display={"flex"} justifyContent={"space-between"}>
        <Typography
          component={"div"}
          sx={{
            fontSize: {
              xl: "24px",
              lg: "24px",
              md: "23px",
              sm: "21px",
              xs: "19px",
            },
            color: "#000000",
          }}
        >
          EatCoast Gift Card
        </Typography>
        <Link
          to={"#"}
          onClick={handleOpenModal}
          sx={{
            fontSize: "16px",
            fontWeight: "400",
            color: "#000000",
            paddingTop: "4px",
          }}
        >
          <span style={{ color: "#2B817B" }}>Gift Card History</span>
        </Link>
      </Box>
      <Box component={"div"} display={"flex"} my={2}>
        <Typography
          component={"div"}
          sx={{
            fontSize: {
              md: "16px",
              sm: "16px",
              xs: "14px",
            },
            color: "#545359",
          }}
        >
          Send a gift card with some credit to other users.
        </Typography>
      </Box>

      <Box
        component={"div"}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Box
          sx={{
            width: {
              xl: "320px",
              lg: "320px",
              md: "330px",
              sm: "320px",
              xs: "320px",
            },
            // border: "1px solid red",
            // height: "20vh",
          }}
        >
          <Slider {...settings}>
            {imgArr.map((v, i) => {
              return (
                <Box key={i}>
                  <img
                    src={v.img}
                    alt="yeh images hai check "
                    onError={() =>
                      console.error(`Failed to load image: ${v.img}`)
                    }
                    style={{
                      // border: "1px solid red",
                      height: "22vh",
                      width: "100%",
                    }}
                  />
                </Box>
              );
            })}
          </Slider>
        </Box>
      </Box>
      <Box
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          // border: "1px solid red",
          py: 2,
        }}
      >
        <Box>
          <Typography
            sx={{
              fontSize: "20px",
              fontWeight: "500",
              color: "#1a1b24",
              lineHeight: "28px",
              mt: 3,
            }}
          >
            Card Value (CAD)
          </Typography>
          <Box sx={{ mt: 2, mb: 1 }}>
            <Chip
              label="$ 16"
              variant="outlined"
              sx={{ marginRight: "10px" }}
            />
            <Chip
              label="$ 190"
              variant="outlined"
              sx={{ marginRight: "10px" }}
            />
            <Chip
              label="$ 24"
              variant="outlined"
              sx={{ marginRight: "10px" }}
            />
          </Box>
          <Link to={"#"} sx={{ color: "#2B817B", marginTop: "20px" }}>
            {" "}
            <span
              style={{ fontSize: "16px", fontWeight: "400", color: "#2B817B" }}
            >
              Customer value
            </span>{" "}
          </Link>
          <Typography
            sx={{
              mt: 2,
              fontSize: "20px",
              fontWeight: "600",
              color: "#1a1b24",
              lineHeight: "28px",
            }}
          >
            Send Giftcard To:
          </Typography>
          <Box sx={{ marginTop: "33px" }}>
            <InputLabel
              className="inputlabel"
              sx={{
                fontSize: "20px",
                color: "#1a1824",
                fontWeight: "500",
              }}
            >
              Full name
            </InputLabel>
            <Box
              sx={{
                width: 500,
                maxWidth: "100%",
              }}
            >
              <TextField
                className="inputfield"
                fullWidth
                label="Enter your full name"
                id="name"
              />
            </Box>
          </Box>

          <Box sx={{ marginTop: "24px" }}>
            <InputLabel
              className="inputlabel"
              sx={{
                fontSize: "20px",
                color: "#1a1824",
                fontWeight: "500",
              }}
            >
              Email
            </InputLabel>
            <Box
              sx={{
                width: 500,
                maxWidth: "100%",
              }}
            >
              <TextField
                className="inputfield"
                fullWidth
                label="Enter your email address"
                id="email"
              />
            </Box>
          </Box>

          <Box sx={{ marginTop: "24px" }}>
            <InputLabel
              className="inputlabel"
              sx={{
                fontSize: "20px",
                color: "#1a1824",
                fontWeight: "500",
              }}
            >
              Gift Message
            </InputLabel>
            <Box
              sx={{
                width: 500,
                maxWidth: "100%",
              }}
            >
              <TextField
                className="inputfield"
                fullWidth
                label="Type message here"
                id="message"
              />
            </Box>
          </Box>

          <Typography
            sx={{
              mt: 3,
              fontSize: "20px",
              fontWeight: "600",
              color: "#1a1b24",
              lineHeight: "28px",
            }}
          >
            Giftcard From:
          </Typography>
          <Box sx={{ marginTop: "33px" }}>
            <InputLabel
              className="inputlabel"
              sx={{
                fontSize: "20px",
                color: "#1a1824",
                fontWeight: "500",
              }}
            >
              Full name
            </InputLabel>
            <Box
              sx={{
                width: 500,
                maxWidth: "100%",
              }}
            >
              <TextField
                className="inputfield"
                fullWidth
                label="Enter your full name"
                id="name"
              />
            </Box>
          </Box>

          <Box sx={{ marginTop: "24px" }}>
            <Box display={"flex"} justifyContent={"space-between"}>
              <InputLabel
                className="inputlabel"
                sx={{
                  fontSize: "20px",
                  color: "#1a1824",
                  fontWeight: "500",
                }}
              >
                Sending date{" "}
              </InputLabel>
              <Link sx={{ color: "#2B817B", marginTop: "20px" }}>
                {" "}
                <a
                  style={{
                    fontSize: "16px",
                    fontWeight: "400",
                    color: "#2B817B",
                  }}
                >
                  Edit
                </a>{" "}
              </Link>
            </Box>
            <Box
              sx={{
                width: 500,
                maxWidth: "100%",
              }}
            >
              <TextField
                className="inputfield"
                fullWidth
                label="Today"
                id="date"
              />
            </Box>
          </Box>

          <Box sx={{ marginTop: "24px" }}>
            <Box display={"flex"} justifyContent={"space-between"}>
              <InputLabel
                className="inputlabel"
                sx={{
                  fontSize: "20px",
                  color: "#1a1824",
                  fontWeight: "500",
                }}
              >
                Pay with
              </InputLabel>
              <Link to={"#"} sx={{ color: "#2B817B", marginTop: "20px" }}>
                {" "}
                <span
                  style={{
                    fontSize: "16px",
                    fontWeight: "400",
                    color: "#2B817B",
                  }}
                >
                  Edit
                </span>{" "}
              </Link>
            </Box>
            <Box
              sx={{
                width: 500,
                maxWidth: "100%",
              }}
            >
              <TextField
                className="inputfield"
                fullWidth
                label="Type *** 123"
                id="paywith"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <img src="../images/visa.svg" alt="" />
                    </InputAdornment>
                  ),
                }}
              />
            </Box>
            <Button
              variant="contained"
              sx={{
                backgroundColor: "#2B817B",
                width: "267px",
                height: "48px",
                color: "#FFFFFF",
                fontSize: "16px",
                fontWeight: "600",
                textTransform: "capitalize",
                letterSpacing: "0.015em",
                marginTop: "16px",
                borderRadius: "6px",
                my:2
              }}
            >
              Buy Gift Card
            </Button>
          </Box>
        </Box>
      </Box>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={open}>
          <Box sx={style} mb={3}>
            <Box textAlign={"center"}>
              <img src="../../images/refferalcode.svg" alt="" />
            </Box>
            <Typography
              textAlign={"center"}
              sx={{
                margin: "10px 0px",
                fontFamily: "Outfit",
                fontSize: "16px",
                color: "#1a1824",
                fontWeight: "400",
              }}
              id="transition-modal-title"
              variant="h6"
              component="h2"
            >
              Refferal Code
            </Typography>
            <Typography
              textAlign={"center"}
              sx={{
                margin: "05px 0px",
                fontFamily: "Outfit",
                fontSize: "24px",
                color: "#1a1824",
                fontWeight: "600",
              }}
              variant="h3"
              component="h3"
            >
              F112M4V
            </Typography>
            <Typography
              sx={{
                margin: "10px 0px",
                fontFamily: "Outfit",
                fontSize: "16px",
                color: "#545359",
                fontWeight: "400",
              }}
              textAlign={"center"}
              id="transition-modal-description"
            >
              Share your code with a friends. When they use for the first order,
              you both get $10 off a $20order.
            </Typography>
            <Button
              variant="contained"
              sx={{
                backgroundColor: "#2B817B",
                width: "267px",
                height: "38px",
                color: "#FFFFFF",
                fontSize: "16px",
                fontWeight: "600",
                textTransform: "capitalize",
                letterSpacing: "0.015em",
                width: "100%",
                marginTop: "16px",
                borderRadius: "6px",
              }}
            >
              <BsLink />
              Copy URL Link
            </Button>
            <Button
              variant="contained"
              sx={{
                backgroundColor: "#2B817B",
                width: "267px",
                height: "38px",
                color: "#FFFFFF",
                fontSize: "16px",
                fontWeight: "600",
                textTransform: "capitalize",
                letterSpacing: "0.015em",
                width: "100%",
                marginTop: "16px",
                borderRadius: "6px",
              }}
            >
              <img
                src="../../images/whatsapp.svg"
                alt=""
                sx={{ marginRight: "10px" }}
              />{" "}
              Telegram Whatsapp
            </Button>
            <Button
              variant="contained"
              sx={{
                backgroundColor: "#2B817B",
                width: "267px",
                height: "38px",
                color: "#FFFFFF",
                fontSize: "16px",
                fontWeight: "600",
                textTransform: "capitalize",
                letterSpacing: "0.015em",
                width: "100%",
                marginTop: "16px",
                borderRadius: "6px",
              }}
            >
              <img
                src="../../images/telegram.svg"
                alt=""
                sx={{ marginRight: "10px" }}
              />{" "}
              Telegram
            </Button>
          </Box>
        </Fade>
      </Modal>
    </Box>
  );
};

export default GiftCard;
